<template>
  <div class="statistic" id="cnt-comments" v-if="isView()">
    <div class="statistic-item badge bg">
      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="icon icon-tabler icons-tabler-outline icon-tabler-message me-1">
        <path stroke="none" d="M0 0h24v24H0z" fill="none"/><path d="M8 9h8" />
        <path d="M8 13h6" />
        <path d="M18 4a3 3 0 0 1 3 3v8a3 3 0 0 1 -3 3h-5l-5 3v-3h-2a3 3 0 0 1 -3 -3v-8a3 3 0 0 1 3 -3h12z" />
      </svg>
      <span class="count">{{ getCntCommentsField() }}</span>
    </div>
  </div>
</template>

<script>
import {defineComponent, onMounted, reactive} from "vue"
export default defineComponent({
  name: "CntComments",
  props: {
    payload: {
      type: Object,
      required: true
    },
  },
  setup(props) {
    const fields = reactive({
      cnt_comments: null,
    })

    onMounted(() => {
      updateFields(props.payload)
    })

    function updateFields(pl) {
      fields.cnt_comments = pl?.cnt_comments
    }

    function hasCntComments() {
      return fields.cnt_comments !== undefined && fields.cnt_comments > 0
    }

    function getCntCommentsField() {
      return fields.cnt_comments
    }
    
    function isView() {
      return hasCntComments()
    }

    return {
      isView,
      getCntCommentsField,
    }
  }
})
</script>

<style scoped src="./css/style.css"></style>
